import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";
import { ROLE } from '../../enums/roles';
import { hasRole } from '../../utils/hasRole';
import DragNDropUpload from "../dran-n-drop-upload/drag-n-drop-upload.component";

import './translation-carousel.styles.scss';

export default function TranslationCarousel({ images, handleUpload, handleDelete }) {
    const { state } = useContext(Context);

    const [photos, setPhotos] = useState([]);
    const [roles, setRoles] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [displayLoading, setDisplayLoading] = useState(false);

    useEffect(() => {
        setRoles(state.roles)
    }, [state.roles]);

    useEffect(() => {
        setDisplayLoading(false);
    }, [images]);

    useEffect(() => {
        if (photos.length > 0) {
            setDisplayLoading(true);
            handleUpload(photos);
        }
    }, [photos]);

  const deletePhoto = (photoId, index) => {
    const newIndex = images.length - 1 === index ? (index - 1) : index;
    setCurrentIndex(newIndex);
    handleDelete(photoId)
  }

    return (
        <div className='translation-carousel-container'>
            {images.length > 0 ?
                <div id="translationCarousel" className="carousel slide" data-ride="carousel" data-interval="false">
                    <div className="carousel-inner">
                        {images.map((image, index) => (
                          <div key={index} className={index === currentIndex ? "carousel-item active" : "carousel-item"}>
                            <a href="#translation-lightbox" data-toggle="modal" rel="noopener noreferrer">
                              <img className="d-block w-100" src={image.path} alt="First slide" />
                            </a>
                            {hasRole(roles, ROLE.ADMIN) && <button className={`btn btn-delete-photos`} onClick={() => deletePhoto(image.id, index)}><i className="far fa-trash-alt"></i></button>}
                          </div>
                        ))}
                    </div>
                    <ol className="carousel-indicators">
                        {images.map((image, index) => (<li key={index} data-target="#translationCarousel" data-slide-to={index}  onClick={() => setCurrentIndex(index)}><span>{index + 1}</span></li>))}
                    </ol>
                </div> :
                <div className="d-flex justify-content-center align-items-center images-placeholder">
                    <i className="far fa-images"></i>
                </div>
            }

            <div className="modal fade" id="translation-lightbox" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {images.length > 0 &&
                                images.map((image, index) => (<img key={index} className={index === currentIndex ? "d-block w-100" : "d-none"} src={image.path} />))
                            }
                        </div>
                    </div>
                </div>
            </div>

            {hasRole(roles, ROLE.ADMIN) &&
                <DragNDropUpload onSubmit={setPhotos} autoSubmit={true}/>}
        </div>
    )

}
